import { Box, Grid } from '@mui/material';
import QueueMediaComponent from './queue-media';
import { QueueFileData } from '../../redux/reducer/galleryReducer';
import DraggableImage from './DraggableImage';
import { ImageMetadata } from '../../types/ui';
import React, { useMemo, useState } from 'react';
import ImageDialog from './ImageDialog';
type ImageSelectBoxProps = {
  uploadQueue: QueueFileData[];
  expanded?: boolean;
  unlabeledImages?: ImageMetadata[];
  selectedGuids: string[];
  onSelectMediaFile: (guid: string) => void;
};
const ImageSelectBox: React.FC<ImageSelectBoxProps> = ({
  uploadQueue = [],
  expanded = false,
  unlabeledImages = [],
  selectedGuids = [],
  onSelectMediaFile,
}) => {
  const [imageDialog, setImageDialog] = useState<{
    visible: boolean;
    index: number;
  }>({ visible: false, index: -1 });

  return (
    <Box>
      <Grid container spacing={2}>
        {uploadQueue?.map((media, index: number) => (
          <Grid item xs={4} key={index}>
            <QueueMediaComponent
              media={media}
              index={index}
              expanded={expanded}
            />
          </Grid>
        ))}
        {unlabeledImages?.map((media, index: number) => (
          <Grid item xs={4} key={index}>
            <DraggableImage
              expanded={expanded}
              image={media}
              index={index}
              title={`${media?.prefix ? media?.prefix + ':' : ''}  ${media?.description ? media?.description?.toLanguagePack() : media?.imageFileName}`}
              isSelected={selectedGuids.includes(media.guid)}
              onItemClick={() => onSelectMediaFile(media.guid)}
              onDoubleClickView={() =>
                setImageDialog({
                  visible: true,
                  index,
                })
              }
              selectedGuids={selectedGuids} // <-- add this
              unlabeledImages={unlabeledImages} // <-- add this
            />
          </Grid>
        ))}
      </Grid>
      <Box>
        <ImageDialog
          images={unlabeledImages}
          open={imageDialog.visible}
          initialIndex={imageDialog.index}
          onClose={() =>
            setImageDialog((prev) => ({ ...prev, visible: false }))
          }
        />
      </Box>
    </Box>
  );
};

export default ImageSelectBox;
